var _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSelectionStats(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 12,
    height: 12,
    viewBox: "0 0 12 12",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "nonzero",
    fill: "rgb(0%, 59.214783%, 27.058411%)",
    fillOpacity: 1,
    d: "M 1 6 L 3.5 6 L 3.5 10.5 L 1 10.5 Z M 1 6 "
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "nonzero",
    fill: "rgb(0%, 59.214783%, 27.058411%)",
    fillOpacity: 1,
    d: "M 4.5 2 L 7.5 2 L 7.5 10.5 L 4.5 10.5 Z M 4.5 2 "
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "nonzero",
    fill: "rgb(0%, 59.214783%, 27.058411%)",
    fillOpacity: 1,
    d: "M 8.5 4.5 L 11 4.5 L 11 10.5 L 8.5 10.5 Z M 8.5 4.5 "
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSelectionStats);
export default __webpack_public_path__ + "static/media/selection_stats.73854da2ebc4bebc2ef61b9ed5d4a271.svg";
export { ForwardRef as ReactComponent };